//  mapboxgl.accessToken = 'pk.eyJ1IjoicHhoZWFsdGgiLCJhIjoiY21ndDlzMHYzMDF0dzJqcXdrcHdmc2xlaiJ9.IIwCUMUNu0lspffifgRc1A';

// const map = new mapboxgl.Map({
//     container: 'map',
//     style: 'mapbox://styles/pxhealth/cmgtc0if7000h01r118socb9b',
//     center: [10, 47],
//     zoom: 4.3,
//     projection: 'globe'
// });

// map.addControl(new mapboxgl.NavigationControl());

// // Random color palette similar to your screenshot
// const colors = ['#49BFE0', '#45B6AF', '#F5D34E', '#2CA6C9', '#5ED5C5'];

// // Example city coordinates across Europe
// const locations = [
//     { coords: [2.3522, 48.8566], name: "Paris" },
//     { coords: [11.5820, 48.1351], name: "Munich" },
//     { coords: [12.4964, 41.9028], name: "Rome" },
//     { coords: [-3.7038, 40.4168], name: "Madrid" },
//     { coords: [7.4474, 46.9480], name: "Bern" },
//     { coords: [8.6821, 50.1109], name: "Frankfurt" },
//     { coords: [6.9603, 50.9375], name: "Cologne" },
//     { coords: [14.5058, 46.0569], name: "Ljubljana" },
//     { coords: [19.0402, 47.4979], name: "Budapest" },
//     { coords: [13.4050, 52.5200], name: "Berlin" }
// ];

// // Create custom “pin” marker with random color
// locations.forEach(loc => {
//     const color = colors[Math.floor(Math.random() * colors.length)];

//     const el = document.createElement('div');
//     el.innerHTML = `
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="${color}">
//             <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 
//             0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 
//             1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
//         </svg>
//     `;
//     el.style.cursor = 'pointer';

//     new mapboxgl.Marker(el)
//         .setLngLat(loc.coords)
//         .setPopup(new mapboxgl.Popup().setHTML(`
            
//             <div class="main-info-map-wap">
//   <div class="map-info-inner-wapper">
//       <div class="image-heanding-wapper">
//         <div class="image-wapper">
//            <img
//             src="https://cdn.shopify.com/s/files/1/0982/5632/2900/files/d9a03d7b072c38d6640e247295af9f13_150x.png?v=1758538005"
//             alt="map-autho"
//             loading="lazy"
//           >
//         </div>
//         <div class="main-infor-title">
//           <h2 class="headding">${loc.name}</h2>
//           <h3 class="sub-headding">Title / Beschreibung</h3>
//         </div>
//       <div>
//       <div class="content-main-wapper">
//         <div class="content-wapper">
//           <p>Kurzbeschreibung… dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut la dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor</p>
//         </div>
//         <div class="button-wapper">
//           <a href="#" class="button"> MEHR ERFAHREN 
//           <svg id="Group_67550" data-name="Group 67550" xmlns="http://www.w3.org/2000/svg" width="15" height="14.451" viewBox="0 0 14.451 14.451">
//             <g id="Group_67549" data-name="Group 67549">
//               <path id="Path_111179" data-name="Path 111179" d="M7.226,0a7.226,7.226,0,1,0,7.226,7.226A7.234,7.234,0,0,0,7.226,0ZM9.458,7.651,6.447,10.662A.6.6,0,1,1,5.6,9.811L8.181,7.226,5.6,4.641a.6.6,0,0,1,.851-.851L9.458,6.8A.6.6,0,0,1,9.458,7.651Z" fill="#1A2F4B"></path>
//             </g>
//           </svg>
//           </a>
//         </div>          
//       </div>
//   </div>
// </div>`))
//         .addTo(map);
// });

  mapboxgl.accessToken = 'pk.eyJ1IjoicHhoZWFsdGgiLCJhIjoiY21ndDlzMHYzMDF0dzJqcXdrcHdmc2xlaiJ9.IIwCUMUNu0lspffifgRc1A';

 const map = new mapboxgl.Map({
     container: 'map',
     style: 'mapbox://styles/pxhealth/cmgtc0if7000h01r118socb9b',
     center: [10, 47],
     zoom: 4.3,
     projection: 'globe'
 });

 map.addControl(new mapboxgl.NavigationControl());

//  Random color palette similar to your screenshot
 const colors = ['#49BFE0', '#45B6AF', '#F5D34E', '#2CA6C9', '#5ED5C5'];


//   // ✅ Defensive check to avoid undefined or empty array issues
   let locations = [];
   if (Array.isArray(window.blocks_schema) && window.blocks_schema.length > 0) {
      locations = window.blocks_schema.map(block => ({
       coords: [parseFloat(block.long), parseFloat(block.lat)],
       image:block.image,
       name: block.name,
       title: block.title,
      desc: block.desc,
       btn_text:block.btn_text,
       btn_link:block.btn_link
     }));
     console.log("locations", locations);
   } else {
     console.warn("⚠️ No valid blocks found in window.blocks_schema:", window.blocks_schema);
   }

// // Create custom “pin” marker with random color
 locations.forEach(loc => {
  const color = colors[Math.floor(Math.random() * colors.length)];

  const el = document.createElement('div');
  el.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="${color}">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 
       0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 
       1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
    </svg>
  `;
  el.style.cursor = 'pointer';

  // Build popup HTML dynamically
  let popupHTML = `
    <div class="main-info-map-wap">
      <div class="map-info-inner-wapper">
        <div class="image-heanding-wapper">
  `;

  // ✅ Include image only if valid
  if (loc.image && loc.image.trim() !== '') {
    popupHTML += `
      <div class="image-wapper">
        <img src="${loc.image}" alt="map-author" loading="lazy">
      </div>
    `;
  }

  // ✅ Include name/title if at least one exists
  if ((loc.name && loc.name.trim() !== '') || (loc.title && loc.title.trim() !== '')) {
    popupHTML += `
      <div class="main-infor-title">
        ${loc.name ? `<h2 class="headding">${loc.name}</h2>` : ''}
        ${loc.title ? `<h3 class="sub-headding">${loc.title}</h3>` : ''}
      </div>
    `;
  }

  popupHTML += `
        </div>
        <div class="content-main-wapper">
  `;

  // ✅ Include description if available
  if (loc.desc && loc.desc.trim() !== '') {
    popupHTML += `
      <div class="content-wapper">
        <p>${loc.desc}</p>
      </div>
    `;
  }

  // ✅ Include button only if both text & link exist
  if (loc.btn_link && loc.btn_link.trim() !== '' && loc.btn_text && loc.btn_text.trim() !== '') {
    popupHTML += `
      <div class="button-wapper">
        <a href="${loc.btn_link}" class="button" target="_blank">${loc.btn_text}
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14.451" viewBox="0 0 14.451 14.451">
            <path d="M7.226,0a7.226,7.226,0,1,0,7.226,7.226A7.234,7.234,0,0,0,7.226,0ZM9.458,7.651,6.447,10.662A.6.6,0,1,1,5.6,9.811L8.181,7.226,5.6,4.641a.6.6,0,0,1,.851-.851L9.458,6.8A.6.6,0,0,1,9.458,7.651Z" fill="#1A2F4B"></path>
          </svg>
        </a>
      </div>
    `;
  }

  popupHTML += `
        </div>
      </div>
    </div>
  `;

  // ✅ Add marker to map
  new mapboxgl.Marker(el)
    .setLngLat(loc.coords)
    .setPopup(new mapboxgl.Popup().setHTML(popupHTML))
    .addTo(map);
});
